import { reseller, pagination } from "./templates";

export default {
	resellers: [],
	reseller: { ...reseller },
	pagination: { ...pagination }
};
